import { createCrudSlice } from './createCrudSlice';
import { stepRisersApi } from '../../services/api';

const { reducer, actions } = createCrudSlice('stepRisers', stepRisersApi);

export const {
  fetchAll: fetchStepRisers,
  fetchById: fetchStepRiserById,
  create: createStepRiser,
  update: updateStepRiser,
  remove: deleteStepRiser,
  clearError,
  clearCurrentItem,
} = actions;

export default reducer;
